<template>
  <div v-if="false"></div>
</template>

<script>
  export default {
    name: "vf-drawer-item"
  }
</script>

<style scoped>

</style>
